import { CampaignModel, factoryMenuSetting } from '.'

export class CompoundCampaignModel {
  constructor(item = {}) {
    const { advertiserId, insertionOrderId, campaign, menuSetting } = item
    this.advertiserId = advertiserId
    this.insertionOrderId = insertionOrderId
    this.campaign = new CampaignModel(campaign)
    this.menuSetting = factoryMenuSetting(campaign.menuType, menuSetting)
  }

  static assign(data) {
    return new CompoundCampaignModel(data)
  }
}
